export default __webpack_public_path__ + "static/media/dashboard-empty-state.2f906523.jpg";